/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { DocArrowOutIcon16Light } from './DocArrowOutIcon16Light';
import { DocArrowOutIcon16Regular } from './DocArrowOutIcon16Regular';
import { DocArrowOutIcon16Solid } from './DocArrowOutIcon16Solid';
import { DocArrowOutIcon20Light } from './DocArrowOutIcon20Light';
import { DocArrowOutIcon20Regular } from './DocArrowOutIcon20Regular';
import { DocArrowOutIcon20Solid } from './DocArrowOutIcon20Solid';
import { DocArrowOutIcon24Regular } from './DocArrowOutIcon24Regular';
import { DocArrowOutIcon24Solid } from './DocArrowOutIcon24Solid';
import { DocArrowOutIcon32Regular } from './DocArrowOutIcon32Regular';
import { DocArrowOutIcon64Regular } from './DocArrowOutIcon64Regular';
var sizes = {
    16: {
        light: DocArrowOutIcon16Light,
        regular: DocArrowOutIcon16Regular,
        solid: DocArrowOutIcon16Solid,
    },
    20: {
        light: DocArrowOutIcon20Light,
        regular: DocArrowOutIcon20Regular,
        solid: DocArrowOutIcon20Solid,
    },
    24: {
        regular: DocArrowOutIcon24Regular,
        solid: DocArrowOutIcon24Solid,
    },
    32: {
        regular: DocArrowOutIcon32Regular,
    },
    64: {
        regular: DocArrowOutIcon64Regular,
    },
};
export var DocArrowOutIcon = forwardRef('DocArrowOutIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
